import { ADD_ANIMAL, ADD_USER } from './actions';

const initialState = {
    user: {},
    animal: {},
}

function appReducer(state = initialState, action) {
    switch(action.type) {
        case ADD_USER:
        return Object.assign({}, state, {
            user: action.user,
        })
        case ADD_ANIMAL: 
        return Object.assign({}, state, {
            animal: action.animal, 
        })
        default: 
        return state
    }
}

export default appReducer


// WEBPACK FOOTER //
// ./src/redux/reducers.js